module.exports = __webpack_public_path__ + "img/av050.e6b38cfc.png";